<template>
  <el-dialog
    :title="$t('app.edit')"
    :visible.sync="dialogVisible"
    width="960px"
  >
    <el-row class="container scroll-bar">
      <el-form label-width="200px">
        <el-col
          :span="
            [
              'Remark1',
              'Remark2',
              'Remark3',
              'Remark4',
              'SpecialType',
              'WithMentalOrHealthIssue',
              'PaymentType',
            ].includes(i)
              ? 24
              : 12
          "
          v-for="i in Object.keys(obj)"
          :key="i"
        >
          <el-form-item :label="i != 'SpecialTypeDetail' ? obj[i].Lable : ''">
            <el-select
              v-if="i == 'AdmissionType'"
              v-model="obj[i].Value"
              placeholder="請選擇"
              :disabled="!obj[i].CanEdit"
              style="width: 238px"
            >
              <el-option
                v-for="item in homeTownOptions"
                :key="item.CODE"
                :label="item.TEXT"
                :value="item.CODE"
              >
              </el-option>
            </el-select>
            <template v-else-if="['SpecialType'].includes(i)">
              <el-radio-group
                :disabled="!obj[i].CanEdit"
                v-model="obj[i].Value"
              >
                <el-radio :label="'0'">None</el-radio>
                <el-radio :label="'1'">Scholarship Recipient</el-radio>
                <el-radio :label="'2'">Trainee</el-radio>
                <el-radio :label="'3'">Others</el-radio>
              </el-radio-group>
              <el-input
                v-if="obj[i].Value == '1'"
                placeholder="請輸入獎學金資料"
                v-model="obj['SpecialTypeDetail'].Value"
              >
              </el-input>
            </template>

            <el-input
              v-else-if="
                ['Remark1', 'Remark2', 'Remark3', 'Remark4'].includes(i)
              "
              type="textarea"
              :disabled="!obj[i].CanEdit"
              v-model="obj[i].Value"
              :rows="3"
              :maxlength="1000"
              placeholder="最大不超過1000字"
            ></el-input>
            <el-input
              v-else-if="!['SpecialTypeDetail'].includes(i)"
              :disabled="!obj[i].CanEdit"
              v-model="obj[i].Value"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false" type="info">{{
        $t("app.cancel")
      }}</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        @click="handleClose"
      >
        更新
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import { updInfo } from "@/api/document/student";
import { getAdmissionType } from "@/api/report/checkInReport";
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      index: "",
      obj: {},
      homeTownOptions: [],
    };
  },
  created() {
    this.getHomeTown();
  },
  methods: {
    edit(index, row) {
      this.dialogVisible = true;
      this.index = index;
      const obj = JSON.parse(JSON.stringify(row));
      Object.keys(obj).forEach((_) => {
        if (obj[_] === null) return;
        if (_ === "SpecialType") {
          if (obj[_].Value === null || obj[_].Value === undefined) {
            obj[_].Value = "";
          }
        }
        this.$set(this.obj, _, obj[_]);
      });
    },
    handleClose() {
      this.$confirm(this.$t("app.confirmModification")).then(() => {
        this.loading = true;
        updInfo({
          StudentCode: this.obj.StudentId.Value
            ? this.obj.StudentId.Value
            : this.obj.ApplicationCode.Value,
          UpdateModel: {
            SpecialType: this.obj.SpecialType.Value,
            SpecialTypeDetail: this.obj.SpecialTypeDetail.Value,
            Remark1: this.obj.Remark1.Value,
            Remark2: this.obj.Remark2.Value,
            Remark3: this.obj.Remark3.Value,
            Remark4: this.obj.Remark4.Value,
            Warning: this.obj.Warning.Value,
            Visitors: this.obj.Visitors.Value,
            LateReturn: this.obj.LateReturn.Value,
            StayOutsideOvernight: this.obj.StayOutsideOvernight.Value,
            VenueBooking: this.obj.VenueBooking.Value,
            BorrowItem: this.obj.BorrowItem.Value,
            OpenDoor: this.obj.OpenDoor.Value,
            RoomChange: this.obj.RoomChange.Value,
            PaymentType: this.obj.PaymentType.Value,
            AdmissionType: this.obj.AdmissionType.Value,
          },
        })
          .then(() => {
            this.success();
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    success() {
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success",
      });
      this.$emit("handleSuccess", this.index, this.obj);
      this.loading = false;
      this.dialogVisible = false;
    },
    getHomeTown() {
      getAdmissionType().then((res) => {
        this.homeTownOptions = res.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 0 20px;
  height: 500px;
  overflow: auto;
}
</style>
